import { addressSchema } from "@/components/Forms/schema/addressSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceSelector } from "jsonapi-zod-query";

const addressTypeSelector = createResourceSelector({
    type: "address",
    attributesSchema: addressSchema,
});

export type Address = ReturnType<typeof addressTypeSelector>;

type Props = {
    addressUUID: string | null;
    isQueryEnabled?: boolean;
};
export const useFetchAddress = ({
    isQueryEnabled = true,
    addressUUID,
}: Props): UseQueryResult<Address> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["address", addressUUID],
        enabled: isQueryEnabled,
        queryFn: async () => {
            const fetchURL = apiUrl(`/address/${addressUUID}`);

            const response = await fetch(fetchURL.href, {
                method: "GET",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: addressTypeSelector,
    });
};
